import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2026-01-31 22:57:43 +0100 (Sat, 31 Jan 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 160223 $
//  Purpose   : parts for vls state system
// =============================================================================
// ---Third-party imports
import React, { useState, useEffect } from 'react';
import { Segment, Table, Grid, Header, Dropdown, Image } from 'semantic-ui-react';
// ---Framework imports
import { has, sorted, items, size, isArray, isNil, get } from 'ldash';
import { Actions } from 'uix/registries';
import { funcPart } from 'uix/parts';
import log from 'uix/logging';
import { DomainConfigSegment } from 'uix/config/components';
import { XTab } from 'uix/components';
import connect from 'uix/connect';
// ---Local imports
import { translateState } from './';
import { loadStatesConfig } from './actions';
import { StateDropdown, StateIcon, getSortedStates, configLoaded, statesCompProps } from './components';
// ---Exports
let StateList = connect('StateList', statesCompProps, ({ dname, dstates, loadStatesConfig, i18n, Graphics })=>{
    if (!configLoaded(dname, dstates, loadStatesConfig)) {
        return null;
    }
    let table = (statusType)=>{
        let sortedStates = getSortedStates(dstates, statusType);
        let cols = [
            'mode',
            'group',
            'startstate',
            'nextstate',
            'endstate',
            'scan',
            'skipStructureImport',
            'orderpage',
            'stateOnNewImages',
            'zipcapsule',
            'modsReadonly'
        ];
        cols = cols.filter((col)=>items(dstates[statusType]).some((e)=>e[1][col]));
        let headers = cols.map((col)=>/*#__PURE__*/ _jsx(Table.HeaderCell, {
                children: col
            }, col));
        let format = (e)=>{
            if (isArray(e)) {
                return e.join(',');
            } else if (isNil(e)) {
                return '';
            } else {
                return String(e);
            }
        };
        //~ log(Graphics.states)
        let rows = sortedStates.map(([name, state])=>/*#__PURE__*/ _jsxs(Table.Row, {
                children: [
                    /*#__PURE__*/ _jsxs(Table.Cell, {
                        children: [
                            state.value,
                            ": ",
                            name
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Table.Cell, {
                        children: /*#__PURE__*/ _jsx(StateIcon, {
                            Graphics: Graphics,
                            type: statusType,
                            name: name
                        })
                    }),
                    /*#__PURE__*/ _jsx(Table.Cell, {
                        children: translateState(i18n, statusType, state.value)
                    }),
                    cols.map((col)=>/*#__PURE__*/ _jsx(Table.Cell, {
                            children: format(state[col])
                        }, col))
                ]
            }, name));
        return /*#__PURE__*/ _jsxs(Grid.Column, {
            children: [
                /*#__PURE__*/ _jsxs(Header, {
                    children: [
                        /*#__PURE__*/ _jsx(StateIcon, {
                            Graphics: Graphics,
                            type: statusType
                        }),
                        /*#__PURE__*/ _jsxs("span", {
                            style: {
                                marginLeft: 10
                            },
                            children: [
                                get(i18n, `${statusType}_state_tree`, statusType),
                                " [",
                                statusType,
                                "]"
                            ]
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            style: {
                                marginLeft: 10
                            },
                            children: /*#__PURE__*/ _jsx(StateDropdown, {
                                statusType: statusType
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(Table, {
                    celled: true,
                    definition: true,
                    children: [
                        /*#__PURE__*/ _jsx(Table.Header, {
                            children: /*#__PURE__*/ _jsxs(Table.Row, {
                                children: [
                                    /*#__PURE__*/ _jsx(Table.HeaderCell, {
                                        children: "Name"
                                    }),
                                    /*#__PURE__*/ _jsx(Table.HeaderCell, {
                                        children: "Icon"
                                    }),
                                    /*#__PURE__*/ _jsx(Table.HeaderCell, {
                                        children: "I18n"
                                    }),
                                    headers
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(Table.Body, {
                            children: rows
                        })
                    ]
                })
            ]
        }, statusType);
    };
    let sortedStates = sorted(items(dstates), (e)=>size(e[1]));
    let tables = sortedStates.map(([statusType, v])=>table(statusType));
    return /*#__PURE__*/ _jsx(Segment, {
        children: /*#__PURE__*/ _jsx(Grid, {
            columns: 2,
            divided: true,
            children: /*#__PURE__*/ _jsx(Grid.Row, {
                children: tables
            })
        })
    });
});
export const TestStates = funcPart({
    getGraphics: [
        'states'
    ]
}, ({ dconfig, Graphics })=>{
    //~ filterItems(dconfig.states.modes)
    let pane = (name, children)=>({
            menuItem: name,
            render: ()=>XTab.pane(children)
        });
    let panes = [
        pane('List', /*#__PURE__*/ _jsx(StateList, {
            Graphics: Graphics
        })),
        pane('Config', /*#__PURE__*/ _jsx(DomainConfigSegment, {
            subheader: "Statussystem",
            section: "states",
            levels: 3
        }))
    ];
    return /*#__PURE__*/ _jsx(XTab, {
        panes: panes
    });
});
